import React from 'react';

import WelcomeStaffCard from '../_Components/WelcomeStaffCard';
import WelcomeLicensedCard from '../_Components/WelcomeLicensedCard';

export default function Welcome ({ user, history, match }) {
  if (user.userType === 'Staff') {
    return <WelcomeStaffCard 
      user={user}
      showLicensedTeam={() => {
        history.push(`${match.url}/licensed-teams`)
      }}
      showLocationTeam={() => {
        history.push(`${match.url}/location-teams`)
      }}
    /> 
  }

  if (user.userType === 'Licensed') {
    return <WelcomeLicensedCard
      user={user}
      showAddTeamMember={() => {
        history.push(`${match.url}/team-members`)
      }}
      showAddLocation={() => {
        history.push(`${match.url}/locations`)
      }}
    /> 
  }
}